import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { portfolioCategoriesApi } from "./api";
import type { PortfolioCategoryInput, PortfolioCategoryView } from "./types";

export const portfolioCategoryKeys = {
  all: ["portfolio-categories"] as const,
  publicList: ["portfolio-categories", "public-list"] as const,
};

export function useCategories() {
  return useQuery({
    queryKey: portfolioCategoryKeys.all,
    queryFn: portfolioCategoriesApi.list,
  });
}

export function usePublicCategories() {
  return useQuery({
    queryKey: portfolioCategoryKeys.publicList,
    queryFn: portfolioCategoriesApi.publicList,
  });
}

export function useCreateCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: portfolioCategoriesApi.create,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: portfolioCategoryKeys.all }),
  });
}

export function useUpdateCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ category, input }: { category: PortfolioCategoryView; input: PortfolioCategoryInput }) =>
      portfolioCategoriesApi.update(category.id, input, category.isActive),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: portfolioCategoryKeys.all }),
  });
}

export function useDeleteCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: portfolioCategoriesApi.delete,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: portfolioCategoryKeys.all }),
  });
}
